/* global bodymovin */

const videoLoader = bodymovin.loadAnimation({
  container: document.getElementById('loader'),
  renderer: 'svg',
  loop: true,
  autoplay: true,
  path: `${window.location.origin}/wp-content/themes/terme-sv-martin/theme-includes/animation/terme-loader.json`,
});
